module.exports = __webpack_public_path__ + "static/media/B-SAT.ce759a20.png";